import angular from 'angular';
import _ from 'lodash';

const ClosingServiceFactory = (NewBackendService, $q, $log, endPoints) => {
  'ngInject';

  const backendCall = (request) => $q((resolve, reject) => {
    const URL = 'merchantCatering/getClosedCashList';

    NewBackendService.invokeWebApiPost(URL, request, true).then((result) => {
      $log.debug(`ClosingService`, `getClosingRequest`, result);
      let list = result.data.response.getClosedCashListResponse.closedCashList || [];
      angular.forEach(list, (record) => {
        record.totalTax = JSON.parse(record.totalTax);// eslint-disable-line
      });
      list = _.orderBy(list, 'creationDate', 'desc');
      resolve(list);
    }, (error) => {
      $log.error(`ClosingService`, `getClosingRequest`, error);
      reject(error);
    });
  });

  const service = {
    getClosingByDate: (startDate, endDate) => $q((resolve, reject) => {
      const request = {
        data: {
          request: {
            getClosedCashListRequest: {
              startDate,
              endDate
            }
          }
        }
      };

      backendCall(request).then((data) => {
        resolve(data);
      }, (err) => {
        reject(err);
      });
    }),
    getAllClosing: () => $q((resolve, reject) => {
      const request = {
        data: {
          request: {
            getClosedCashListRequest: {}
          }
        }
      };
      backendCall(request).then((data) => {
        resolve(data);
      }, (err) => {
        reject(err);
      });
    }),
    getPdf: (id) => {
      $log.debug('in Attesa di capire che servizio chiamare...id cassa = ', id);
    },
    makeZip: (closingListChecked, sintesi) => {
      let idString = '';
      angular.forEach(closingListChecked, (record) => {
        idString = `${idString};${record.closedCashId}`;
      });
      const url = `${endPoints.webApiUrl}static-assets/documents/invoice-creditnote/closingCash/asZip/closeCashIds${idString}/${sintesi}`;
      $log.debug('url chiamato  = ', url);
      window.open(url, '_blank');
    }
  };

  return service;
};

export default ClosingServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/closings.factory.js
 **/